import { InformationCircleIcon, TrashIcon } from '@heroicons/react/24/outline'
import React, { useRef } from 'react'
import api from '../../../../middleware/api'
import { toast } from 'react-toastify'
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext'
import PortalModal from '../../../Common/Modal/PortalModal'
import { formatDefaultConfigurationToAddCapsule } from '../../../../utils/capsule_configuration.utils'
import ReagentsModal from '../../../Capsules/ReagentsModal'

const ActionCell = ({ mixtureId, rowIndex, deleteRow, reagents, description, canDelete, mixtureName }) => {
    const { selectedConfigurationId, setCapsuleConfiguration, defaultCapsule } = useCapsuleConfigurator()

    // Use the canDelete prop which is passed directly from the parent component
    // This controls whether the delete action should be available

    const handleDeleteRow = async (e) => {
        try {
            await api.put(`/capsules/configurations/delete/mixture`, {
                configurationId: selectedConfigurationId,
                mixtureId: mixtureId
            })
            deleteRow(rowIndex)
            if (deleteMixtureModal.current) {
                deleteMixtureModal.current.hideModal()
            }
            toast.success('Mélange supprimé')
        } catch (error) {
            console.log(error)
            toast.error('Erreur lors de la suppression du mélange')
        }
    }

    const reagentModal = useRef(null)
    const deleteMixtureModal = useRef(null)

    const handleDuplicateRows = async (e) => {
        try {
            const response = await api.put('/capsules/configurations/duplicate/mixtures', { configurationId: selectedConfigurationId, mixtureIds: [mixtureId] })
            if (response.status === 200) {
                const updatedCapsule = formatDefaultConfigurationToAddCapsule(response.data.configuration, defaultCapsule.name, defaultCapsule.id)
                setCapsuleConfiguration(updatedCapsule)
                toast.success('Les mélanges ont été dupliqués avec succès')
            }

        } catch (e) {
            console.error(e)
            toast.error('Une erreur s\'est produite lors de la duplication des mélanges')
        }
    }




    const handleModalDelete = () => {
        if (deleteMixtureModal.current) {
            deleteMixtureModal.current.showModal()
        } else {
            console.warn('modalRef is not available')
        }
    }

    const hideDeleteModal = () => {
        if (deleteMixtureModal.current) {
            deleteMixtureModal.current.hideModal()
        }
        else {
            console.warn('modalRef is not available')
        }
    }

    return (
        <div className='flex flex-row gap-4 justify-center items-center'>
            {canDelete && (
                <TrashIcon
                    onClick={handleModalDelete}
                    className='w-6 h-6 text-gray-300 hover:text-primary transition-all cursor-pointer'
                />
            )}
      
            {/* <DocumentDuplicateIcon onClick={handleDuplicateRows} className='w-6 h-6 text-gray-300 hover:text-primary transition-all cursor-pointer' /> */}
            <ReagentsModal reagents={reagents} description={description} mixtureName={mixtureName} showPreview={false} />
            <PortalModal ref={deleteMixtureModal}  >
                <div className='p-4 gap-4 flex flex-col items-center'>
                    <p>Êtes vous sur de vouloir supprimer ce mélange ?</p>
                    <div className='flex flex-row gap-4 justify-center items-center '>
                        <button onClick={handleDeleteRow} className='btn btn-primary'>Oui</button>
                        <button onClick={hideDeleteModal} className='btn btn-error'>Non</button>
                    </div>
                </div>
            </PortalModal>

        </div>
    )
}

export default ActionCell
